import GlassesIcon from '@atlaskit/icon/core/glasses';
import React from 'react';

export const SvgSchool = () => (
  <GlassesIcon label="" testId="ads-refreshed-icon" />
);
